export const GET_PRICING = 'GET_PRICING'
export const GET_PRICING_SUCCESS = 'GET_PRICING_SUCCESS'
export const GET_PRICING_ERROR = 'GET_PRICING_ERROR'

export const GET_BRANCHS_PRICING = 'GET_BRANCHS_PRICING'
export const GET_BRANCHS_PRICING_SUCCESS = 'GET_BRANCHS_PRICING_SUCCESS'
export const GET_BRANCHS_PRICING_ERROR = 'GET_BRANCHS_PRICING_ERROR'

export const GET_LANGUAGES_PRICING = 'GET_LANGUAGES_PRICING'
export const GET_LANGUAGES_PRICING_SUCCESS = 'GET_LANGUAGES_PRICING_SUCCESS'
export const GET_LANGUAGES_PRICING_ERROR = 'GET_LANGUAGES_PRICING_ERROR'

export const GET_WORDS_PRICING = 'GET_WORDS_PRICING'
export const GET_WORDS_PRICING_SUCCESS = 'GET_WORDS_PRICING_SUCCESS'
export const GET_WORDS_PRICING_ERROR = 'GET_WORDS_PRICING_ERROR'

export const GET_COMPLETION_TIMES_PRICING = 'GET_COMPLETION_TIMES_PRICING'
export const GET_COMPLETION_TIMES_PRICING_SUCCESS = 'GET_COMPLETION_TIMES_PRICING_SUCCESS'
export const GET_COMPLETION_TIMES_PRICING_ERROR = 'GET_COMPLETION_TIMES_PRICING_ERROR'

export const EDIT_PRICING = 'EDIT_PRICING'
export const EDIT_PRICING_SUCCESS = 'EDIT_PRICING_SUCCESS'
export const EDIT_PRICING_ERROR = 'EDIT_PRICING_ERROR'

export const ADD_NEW_PRICING = 'ADD_NEW_PRICING'
export const ADD_NEW_PRICING_SUCCESS = 'ADD_NEW_PRICING_SUCCESS'
export const ADD_NEW_PRICING_ERROR = 'ADD_NEW_PRICING_ERROR'